import React, {Fragment} from 'react'
import NotFoundImg from '../../../assets/img/404.svg';
import Meta from '../../../components/common/Meta';
import { useTranslation } from 'react-i18next';
import W from '../../../components/common/Word';

const NotFound = () => {
    const { t } = useTranslation();

    return (
        <Fragment>
        {/*
          statusCode=404 makes prerender.io return a real HTTP 404 for this URL.
          Previously this rendered a <meta http-equiv="refresh"> to /{lang}/404,
          which made invalid slugs respond 200 and canonicalize to a 404 URL —
          a soft 404. Now unknown slugs return a genuine 404 at the requested URL.
        */}
        <Meta
            title={t("404")}
            description=""
            robots="noindex"
            statusCode={404}
        />
        <div className="container">
            <div className="row">
                <div className="col page404">

                    <div className="img mb-4">
                        <img alt="Page not found" src={NotFoundImg} />
                    </div>
                    <h2 className="heading--h2">
                        <W>Notfound.title</W>
                    </h2>
                    <p><W>Notfound.subtitle</W></p>
                    <a href="/" className="btn btn--red btn--outline mt-4"><i className="icon-arrow-left mr-2"></i> <W>Notfound.button</W> </a>
                </div>
            </div>
        </div>
        </Fragment>
    )
}

export default NotFound
